function defuse(value: string): string {
  return /^[=+\-@\t\r\n]/.test(value) ? `'${value}` : value;
}

/** One cell: escaped per RFC 4180 - quotes doubled, whole field quoted. */
function cell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '""';
  return `"${defuse(String(value)).replaceAll('"', '""')}"`;
}

export function toCsv(header: string[], rows: (string | number | null | undefined)[][]): string {
  return [header, ...rows].map((row) => row.map(cell).join(',')).join('\r\n');
}

const BOM = String.fromCodePoint(0xfeff);

/** Hands the file to the browser. */
export function downloadCsv(filename: string, csv: string): void {
  downloadBlob(filename, new Blob([`${BOM}${csv}`], { type: 'text/csv;charset=utf-8;' }));
}

/** Hands an already-built file - one the server made - to the browser. */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();

  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}

/** `customers-2026-09-15.csv` - sortable, and unambiguous about which day. */
export function datedFilename(stem: string): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${stem}-${String(now.getFullYear())}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}.csv`;
}
